import './standaloneRequestCard.scss';

import { ScrollableArea } from '@approvalmax/ui';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import ExchangeRate from 'pages/requestList/components/ExchangeRate/ExchangeRate';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import FieldsSection from '../../components/FieldsSection';
import { RequestNoteSection } from '../../components/RequestNoteSection/RequestNoteSection';
import { getActiveRequest } from '../../selectors/pageSelectors';
import ActivitySection from '../card/ActivitySection';
import AddCommentSection from '../card/AddCommentSection/AddCommentSection';
import AttachmentsSection from '../card/AttachmentsSection';
import Toolbar from '../card/Toolbar/Toolbar';
import { WorkflowSection } from '../card/WorkflowSection';
import StandaloneDescriptionSection from './StandaloneDescriptionSection';
import { messages } from './StandaloneRequestCard.messages';
import { StandaloneRequestCardProps } from './StandaloneRequestCard.types';

const bem = bemFactory.block('reql-standalone-request-card');

const StandaloneRequestCard: FC<StandaloneRequestCardProps> = (props) => {
    const { className } = props;
    const request = useSelector(getActiveRequest<selectors.types.StandaloneExpandedRequest>);
    const { date } = request.details;

    return (
        <div className={bem.add(className)()}>
            <Toolbar request={request} className={bem('toolbar')} />

            <ScrollableArea className={bem('scrollable-area')} scrollResetKey={request.id}>
                <div className={bem('scrollable-content')}>
                    <RequestNoteSection text={request.requestNote.value} />

                    <ExchangeRate className={bem('exchange-rate')} request={request} />

                    <StandaloneDescriptionSection />

                    <FieldsSection className={bem('fields-section')}>
                        {date && <FieldsSection.Field title={messages.dateTitle} value={date} />}

                        {request.details.fieldValues
                            .filter((fv) => fv.field.systemPurpose === domain.FieldSystemPurpose.General)
                            .map((fv) => {
                                return (
                                    <FieldsSection.Field
                                        qa={fv.field.id}
                                        key={fv.field.id}
                                        title={fv.field.name}
                                        value={fv.value}
                                    />
                                );
                            })}
                    </FieldsSection>

                    <AttachmentsSection request={request} />

                    <WorkflowSection request={request} />

                    <ActivitySection request={request} />
                </div>
            </ScrollableArea>

            {!request.flags.status.isDraft && (
                <div className={bem('add-comment-section')}>
                    <AddCommentSection request={request} />
                </div>
            )}
        </div>
    );
};

export default memo(StandaloneRequestCard);
